module.exports = " <div class=redirect-timer> <p class=header>You may have been looking for <a class=text-link v-bind:href=url>{{url}}</a>.</p> <div id=redirect-timer-info class=redirect-timer__info> <p class=paragraph> You will be automatically redirected in <span id=redirect-timer-digits class=redirect-timer__digits>{{timeRemaining}}</span> seconds. </p> <binary-choice no-message=stop yes-message=\"go now\"></binary-choice> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RedirectTimer.vue
 ** module id = 13
 ** module chunks = 1
 **/